import TempPP from "../../assets/IMG_2656.jpeg";
import words2 from "../../assets/udpatedwords3.png";

export default function ProfilePictureCard(): JSX.Element {
  return (
    <div className="relative flex justify-center items-center h-full">
      <img
        src={words2}
        alt=""
        aria-hidden="true"
        className="hidden sm:block pointer-events-none select-none fixed top-[78%] left-[55%] -translate-x-1/2 -translate-y-1/2 w-[138vw] sm:w-[118vw] md:w-[108vw] lg:w-[95vw] xl:w-[82vw] max-w-none h-auto opacity-80 z-0"
      />
      <img
        src={TempPP}
        alt="Profile"
        className="w-52 h-52 rounded-full object-cover relative z-10"
      />
    </div>
  );
}
